<template>
  <b-alert class="alert-popUp" :show="dismissCountDown" dismissible @dismissed="dismissCountDown = 0" @dismiss-count-down="countDownChanged">
    <div class="d-flex h-100">
      <div class="rightColor" :style="error ? `background-color: #F46A6A` : `background-color:#4F9B0B`"></div>
      <div class="d-flex align-items-center" style="padding-right: 20px; color: #000">
        {{ title }}
      </div>
    </div>
    <!-- <div @click="dismissCountDownError = false" style="display: flex;justify-content: end;width: 60%; cursor:pointer">
      <i style="font-size: 30px; color: #F46A6A" class="bx bx-x"></i>
    </div> -->
  </b-alert>
</template>

<script>
export default {
  props: {
    title: {
      default: '',
      type: String,
    },
    submit: {
      default: false,
      type: Boolean,
    },
    error: {
      default: false,
      type: Boolean,
    },
    showToast: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      dismissSecs: 4,
      dismissCountDown: 0,
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
  },
  watch: {
    showToast(val) {
      if (val) {
        this.dismissCountDown = this.dismissSecs
      }
    },
  },
}
</script>

<style scoped lang="scss">
.alert-popUp {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  border: none;
  background: #fff;
  align-items: center;
  min-width: 450px;
  border-radius: 9px;
  height: 66px;
  text-align: right;
  position: fixed;
  z-index: 9999;
  bottom: 50px;
  right: 275px;
  padding: 0 !important;
}
.rightColor {
  width: 17px;
  border-radius: 0 8px 8px 0;
}
::v-deep .close {
  display: none;
}
</style>
